import { object } from 'common/helpers'


export const initialState = {
  ids: [],
  items: {},
  isOneOfStoryViewed: false,
  isShowing: false,
  activeItem: null,
  selectedItem: null,
  viewedItems: [],
  finishedItems: [],
  isAllStoriesViewed: false,
  isAllStoriesFinished: false,
}

export const setNormalizeStories = (state, payload) => {
  const ids = []
  const items = {}

  payload.forEach((item) => {
    ids.push(item.id)
    items[item.id] = {
      isViewed: false,
      isSelected: false,
      isFinished: false,
      ...item,
    }
  })

  return { ...state, ids, items }
}

export const reset = () => (
  { ...initialState }
)

export const updateItem = (state, payload) => (
  object.updateIn(state, ['items', payload.id], (item) => ({
    ...item,
    ...payload,
  }))
)

export const setActiveItem = (state, activeItem) => (
  {
    ...state,
    activeItem,
  }
)

export const setItemAsViewed = (state, id) => {
  const viewedItems = [ ...state.viewedItems ]

  let { items } = state
  if (id) {
    if (id && !viewedItems.includes(id)) {
      viewedItems.push(id)
    }

    items = {
      ...items,
      [id]: { ...items[id], isViewed: true },
    }
  }

  return {
    ...state,
    viewedItems,
    items,
    isOneOfStoryViewed: viewedItems.length > 0,
    isAllStoriesViewed: viewedItems.length === state.ids.length,
  }
}

export const setItemAsFinished = (state, id) => {
  const finishedItems = [ ...state.finishedItems ]

  let { items } = state
  if (id) {
    if (id && !finishedItems.includes(id)) {
      finishedItems.push(id)
    }

    items = {
      ...items,
      [id]: { ...items[id], isFinished: true },
    }
  }

  return {
    ...state,
    finishedItems,
    items,
    isAllStoriesFinished: finishedItems.length === state.ids.length,
  }
}

export const toggleItemSelect = (state, payload) => (
  object.update(state, 'items', (items) => {
    const newItems = object.mapValues(items, (item) => ({
      ...item,
      isSelected: false,
    }))

    const item = items[payload]

    return {
      ...newItems,
      [payload]: {
        ...item,
        isSelected: !item.isSelected,
      },
    }
  })
)

export const setSelectedItem = (state, payload) => (
  { ...state, selectedItem: payload }
)

export const toggleStories = (state) => (
  { ...state, isShowing: !state.isShowing }
)
